export default "__VITE_ASSET__C0HR_eDo__"